<template>
  <section id="home">
    <div id="main-slider" class="carousel slide" data-ride="carousel" data-interval="5000" data-pause="" keyboard="true">

      <ol class="carousel-indicators" v-if="project.images.length">
        <li v-for="(image, index) in project.images"
            :key="image.id"
            data-target="#main-slider"
            :class="{active: index === activeSlide}"></li>
      </ol>

      <div class="carousel-inner">
        <div
          v-for="(image, index) in project.images"
          :key="image.id"
          v-if="project.images.length"
          class="item"
          :class="{active: index === activeSlide}">
            <img class="img-responsive" :src="image.image_lg">
        </div>

        <app-vote-now :voteLink="project.voting_link"></app-vote-now>
      </div>
    </div>

  </section>
</template>

<script>
import VoteNow from '@/components/VoteNow.vue'

export default {
  props: {
    project: {
      type: Object,
      default: null
    },
    defaultImage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeSlide: 0,
      slideShowTimer: null,
      slideShowInterval: 4 // in seconds
    }
  },
  components: {
    appVoteNow: VoteNow
  },
  created () {
    this.startSlideShow()
  },
  methods: {
    startSlideShow () {
      let self = this
      const numSlides = this.project.images.length

      this.slideShowTimer = setInterval(function () {
        self.activeSlide = (self.activeSlide + 1) % numSlides
      }, self.slideShowInterval * 1000)
    },
    stopSlideShow () {
      clearInterval(this.slideShowTimer)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HeaderSlideshow.vue